import { Component, OnDestroy, PLATFORM_ID, inject } from '@angular/core';
import { TranslateService as TranslateProvider } from '@ngx-translate/core';
import {
  AnalyticsConfiguration,
  AnalyticsService,
  ApiService,
  AppState,
  CONFIG,
  TranslateService,
  updateAppConfig,
  WindowService,
} from '@gallaghercp/core-frontend';
import { APP_CONFIG } from '@core-app/app.config';
import { Store } from '@ngrx/store';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { X_SERVICE_ZONE } from '@core-app/tokens';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Component({
  selector: 'core-root',
  template: '<router-outlet></router-outlet>',
  standalone: false,
})
export class AppComponent implements OnDestroy {
  private translate = inject(TranslateService);
  private translateProvider = inject(TranslateProvider);
  private analytics = inject(AnalyticsService);
  private api = inject(ApiService);
  private windowService = inject(WindowService);
  private store = inject<Store<AppState>>(Store);
  private router = inject(Router);
  private zone = inject(X_SERVICE_ZONE);
  private platformId = inject(PLATFORM_ID);

  title = 'core-app';
  subscription: Subscription = new Subscription();

  constructor() {
    const translate = this.translate;

    this.analytics.initialise({
      gtm: { id: APP_CONFIG.gtm, consent: 3 },
    } as AnalyticsConfiguration);

    if (this.zone && (isPlatformServer(this.platformId) || isPlatformBrowser(this.platformId))) {
      this.api.setServiceZone(Number(this.zone));
    }

    ((APP_CONFIG as unknown as CONFIG).domainsToZones ?? []).forEach((mapping: any) => {
      if (this.windowService.location?.hostname === mapping.domain) {
        this.api.setServiceZone(mapping.zone);
      }
    });

    if (APP_CONFIG.multilingual) {
      this.translateProvider.setDefaultLang(translate.getDefaultLanguage());
      this.translate.getLanguages().subscribe((languages: any) => {
        this.translateProvider.addLangs(
          languages.map((language: any) => {
            return language.code;
          }),
        );
      });
    }

    this.subscription.add(
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;
        if (!url.startsWith('/ret')) {
          this.store.dispatch(
            updateAppConfig({
              lastVisitedUrl: url,
            }),
          );
        }
        const navigation = this.router.currentNavigation();
        const fromUrl = navigation?.extras?.state?.['from'];
        this.store.dispatch(
          updateAppConfig({
            fromUrl: fromUrl,
          }),
        );
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
